import PageLoader from '@/app/common/components/PageLoader'
import { ProviderQueries } from '@/queries/providers/queries'
import { AppRoutePaths } from '@/routing/route_paths'
import { useQuery } from '@tanstack/react-query'
import { Navigate, useParams } from 'react-router-dom'
import SchoolForm from '../SchoolForm/page'
import { useSelector } from 'react-redux'
import { selectSelectedProgram } from '@/storage/programs/slice'

export default function SchoolFormPage() {
  const providerId = useParams().providerId
  const programId = useSelector(selectSelectedProgram).id

  if (!providerId) {
    throw new Error('ProviderId Not found')
  }

  const providerInfo = useQuery(
    ProviderQueries.getProviderById(programId, providerId)
  )

  return (
    <PageLoader query={providerInfo}>
      {(data) => {
        const isSchoolForm = typeof data.school_application !== 'undefined'

        if (isSchoolForm) {
          return (
            <div>
              <SchoolForm
                schoolInfo={data.school_application!}
                providerInfo={data}
              />
            </div>
          )
        } else {
          return (
            <Navigate
              to={AppRoutePaths.providers.provider_details.provider_info}
            />
          )
        }
      }}
    </PageLoader>
  )
}
